import { Attendance } from "@/@types/esus/Attendance";
import { DentalAttendance } from "@/@types/esus/DentalAttendance";
import { HealthTeam } from "@/@types/esus/HealthTeam";
import { HealthUnit } from "@/@types/esus/HealthUnit";
import { PaginationFilter } from "@/@types/generics/genericals";
import { Paginated } from "@/@types/generics/paginated";
import { esusApi } from "@/services/api";

export type DetailedCitizensAttendancesIndicatorC3Params = PaginationFilter & {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	search: string;
	isEvaluated?: boolean;
	ine?: string;
	export?: boolean;
};

export class DetailedCitizenAttendancesIndicatorC3Data {
	id: number = 0;
	cpf?: string;
	cns?: string;
	birthdate: string = "";
	fullName: string = "";
	healthUnitId: number = 0;
	healthTeamId: number = 0;
	healthUnit?: HealthUnit;
	healthTeam?: HealthTeam;
	area?: string;
	motherName?: string;
	gender?: number;
	street?: string;
	houseNumber?: string;
	neighborhood?: string;
	phone?: string;
	dumDate: string = "";
	dppDate: string = "";
	gestationalAge?: number;
	inactivePregnancyDate?: string;
	pregnancyStatus: "pregnant" | "puerperal" | "finished" = "pregnant";
	firstAttendance?: Attendance;
	firstAttendanceStatus: "finished" | "pending" | "lost" = "lost";
	pregnancyAttendances?: Attendance[];
	sevenPregnancyAttendancesStatus: "finished" | "pending" | "lost" = "lost";
	bloodPressureMeasurements?: Attendance[];
	sevenBloodPressureMeasurementsStatus: "finished" | "pending" | "lost" = "lost";
	weightAndHeightMetricsRegisters?: Attendance[];
	sevenWeightAndHeightMetricsRegistersStatus: "finished" | "pending" | "lost" = "lost";
	dentalAttendances?: DentalAttendance[];
	dentalAttendancesStatus: "finished" | "pending" | "lost" = "lost";
	puerperalAttendance?: Attendance;
	puerperalAttendanceStatus: "finished" | "pending" | "lost" = "lost";
}

export async function getDetailedCitizensAttendancesIndicatorC3({
	uf,
	ibgeCode,
	...params
}: DetailedCitizensAttendancesIndicatorC3Params) {
	const response = await esusApi.get<Paginated<DetailedCitizenAttendancesIndicatorC3Data>>(
		`/uf/${uf}/city/${ibgeCode}/indicator/esf/c3/detailed-citizens-attendances`,
		params
	);
	return response.data ?? new Paginated<DetailedCitizenAttendancesIndicatorC3Data>();
}
